<template>
    <RouterLink :to="url" class="flex flex-col items-center justify-center pt-1.5 pb-.5
                [&.active]:text-violet-600 grow">
        <slot></slot>
        <span class="font-normal">{{ name }}</span>
    </RouterLink>
</template>

<script setup lang="ts">
defineProps({
    url: {
        type: String,
        required: true
    },
    name: {
        type: String,
    }
})
</script>